/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: BCC Pubs
    Author: Johnny Palmer
  Author URL: http://sweetas.xyz
==========================================================================================*/

import axios from '@/axios.js'

export default {

  getMintsoftProducts ( ctx , payload) {    
    return new Promise((resolve, reject) => {      
      axios.post('/Mintsoft/MintsoftProductList', payload)
        .then(response => {   
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  getProducts ({ commit }, payload) {    
    return new Promise((resolve, reject) => {
      // all products from Azure with Stock Count From mintsoft
      axios.get(`/Mintsoft/InfoPointProductList/${payload.IpId}/${payload.StockAlert}`)
        .then(response => {                    
          commit('SET_PRODUCTS', response.data)
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  getAllInfopointSites ({ commit }) {    
    return new Promise((resolve, reject) => {
      axios.get('/Mintsoft/InfoPointSitesList')
        .then(response => {          
          commit('SET_SITES', response.data)
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  getAddressDetails ({ commit }, payload) {    
    return new Promise((resolve, reject) => {
      axios.get(`/Mintsoft/InfoPointDetails/${payload.IpId}`)
        .then(response => {                    
          commit('SET_DETAILS', response.data)
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  setDetails ({ commit }, payload) {     
    return new Promise(resolve => {      
      commit('SET_DETAILS', payload)
      resolve(payload)      
    })            
  },
  setAddressDetails ({ commit }, payload) {     
    return new Promise((resolve, reject) => {
      axios.post('/Mintsoft/InfoPointDetails', payload)
        .then(response => {
          commit('SET_DETAILS', response.data)
          resolve(response)
        })
        .catch(error => { reject(error) })
    })           
  },
  updateDetails ({ commit }, payload) {     
    return new Promise(resolve => {      
      commit('UPDATE_DETAILS', payload)
      resolve(payload)      
    })            
  },
  updateDeliveryDetails ({ commit }, payload) {     
    return new Promise(resolve => {      
      commit('UPDATE_DELIVERY_DETAILS', payload)
      resolve(payload)      
    })            
  },
  updateContactDetails ({ commit }, payload) {     
    return new Promise(resolve => {      
      commit('UPDATE_CONTACT_DETAILS', payload)
      resolve(payload)      
    })            
  },
  updateInfoPointProductList ( ctx , payload) {         
    return new Promise((resolve, reject) => {
      axios.post('/Mintsoft/InfoPointProductListUpdate', payload)
        .then(response => {      
          //commit('SET_DETAILS', response.data)
          resolve(response)
        })
        .catch(error => { reject(error) })
    })    
  },
  UpdateInfopointProductDetails (commit, payload) {     
    return new Promise((resolve, reject) => {
      axios.post('/Mintsoft/UpdateInfopointProductDetails', payload)
        .then(response => {          
          resolve(response)
        })
        .catch(error => { reject(error) })
    })    
  },
  createOrder ( ctx, payload) {    
    return new Promise((resolve, reject) => {
      
      axios.post('/Mintsoft/InfoPointOrder', payload)
        .then(response => {          
          // commit('SET_COMMIT')  
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  importMintsoftProducts () {     
    return new Promise((resolve, reject) => {
      axios.post('/Mintsoft/MintsoftProductListImport')
        .then(response => {          
         //  commit('SET_COMMIT')          
          resolve(response)
        })
        .catch(error => { reject(error) })
    })    
  },
  createPayment (ctx, payload) {
    return new Promise((resolve, reject) => {     
      axios.post('/Payment/Payment', payload)
        .then(response => {          
          resolve(response)
        })
        .catch(error => { reject(error) })
    })     
  },
  getVolunteers () {    
    return new Promise((resolve, reject) => {
      axios.get('/v1/Data/InfoPointVolunteers')
        .then(response => {          
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  updateVolunteer(ctx, payload){
    return new Promise((resolve, reject) => {     
      axios.post('/User/Update', payload)
        .then(response => {          
          resolve(response)
        })
        .catch(error => { reject(error) })
    })  

  },
  getIpTerminalName (ctx, payload) {    
    return new Promise((resolve, reject) => {     
      axios.get(`/Mintsoft/InfoPointTerminalName/${payload.IpId}`)
        .then(response => {          
          resolve(response)
        })
        .catch(error => { reject(error) })
    })     
  },
}
